var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('p',{staticClass:"subheading mb-1 red--text"},[_vm._v(_vm._s(_vm.$t('dashboard.notAllowedForSubscription')))]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'VersionComparison'}}},[_vm._v(_vm._s(_vm.$t('professional.function.overview')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f79f3266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/Dashboard/ContentNotAvailable.vue
// module id = 52XP
// module chunks = 91